const ns = "CATERING_MODULES";
export const ADD_MODULES = `${ns}_ADD_MODULES`;
